import axios from "axios";
import { API_BASE } from "./config";
import { logApiError } from "../utils/apiError";

const api = axios.create({
  baseURL: API_BASE,
});

api.interceptors.request.use(config => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  response => response,
  error => {
    const url = axios.isAxiosError(error) ? error.config?.url : undefined;
    logApiError(url ?? "request", error);
    return Promise.reject(error);
  }
);

export default api;
